<script>
    import user from "@/store/user.js";

    // New online orders now surface in the POS "Online orders" drawer (with a
    // beep + badge), so the old persistent "New Delivery by …" toast is dropped.

    async function sendOrder() {
        if ($user.master) return;
        try {
            const response = await fetch("https://maker.ifttt.com/trigger/JungleHouse Visit/with/key/bpLU8Zu7HFjvDW_4GfagjL", {
                method: "POST",
                mode: "no-cors",

                body: JSON.stringify({ messageData: "messageData" }),
            });

            if (response.ok) {
                console.log("Message sent successfully");
            } else {
                console.log("Error sending message:", response);
            }
        } catch (error) {
            console.error("Error:", error);
        }
    }

    //sendOrder();
</script>
